import { useRoutes, Navigate } from 'react-router-dom';

// routes
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const UndefinedRoutes = {
  path: '*',
  element: <Navigate to="/404" />,
  children: [
    {
      element: <Navigate to="/404" />
    }
  ]
};

export default function ThemeRoutes() {
  return useRoutes([PrivateRoutes, PublicRoutes, UndefinedRoutes], '');
}

// https://stackoverflow.com/questions/62384395/protected-route-with-react-router-v6
